import React from 'react';
import { ExclamationTriangleIcon as Exclamation } from '@heroicons/react/24/outline';
import tw from 'twin.macro';
import clsx from 'clsx';

interface Props {
  title: string;
  children?: React.ReactNode;
  border?: boolean;
  className?: string;
}

export function Alert(props: Props) {
  const { title, children, border } = props;
  return (
    <div
      css={[
        border && tw`border-2 border-danger-intense`,
        tw`rounded-md bg-danger-quiet p-4`,
      ]}
      className={clsx(props.className)}
    >
      <div tw="flex">
        <div tw="shrink-0">
          <Exclamation tw="h-5 w-5 text-danger-quiet" aria-hidden="true" />
        </div>
        <div tw="ml-3">
          <p tw="text-sm font-medium text-danger-intense">{title}</p>
        </div>
        <div tw="ml-auto pl-3">
          <div tw="-mx-1.5 -my-1.5">{children}</div>
        </div>
      </div>
    </div>
  );
}
